import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../../shared/api/api.tokens';
import { BookingRequest } from '../../shared/interfaces';
import { REQUIRE_AUTH } from '../../shared/interceptors/auth-context';
import { API_ENDPOINTS } from '../../shared/common/apiConstants';

@Injectable({ providedIn: 'root' })
export class BookingRequestsService {
  private http = inject(HttpClient);
  private baseUrl = inject(API_BASE_URL);

  getRequests(status?: string): Observable<BookingRequest[]> {
    let params = new HttpParams();
    if (status) params = params.set('status', status);
    return this.http.get<BookingRequest[]>(
      `${this.baseUrl}${API_ENDPOINTS.bookingRequests}`,
      {
        params,
        context: new HttpContext().set(REQUIRE_AUTH, true),
      }
    );
  }

  approveRequest(
    requestId: string,
    payload: { serviceId?: string; startDate?: string; comment?: string }
  ) {
    return this.http.post(
      `${this.baseUrl}${API_ENDPOINTS.bookingRequests}/${requestId}/approve`,
      payload,
      {
        context: new HttpContext().set(REQUIRE_AUTH, true),
      }
    );
  }

  rejectRequest(requestId: string, payload: { reason?: string }) {
    return this.http.post(
      `${this.baseUrl}${API_ENDPOINTS.bookingRequests}/${requestId}/reject`,
      payload,
      {
        context: new HttpContext().set(REQUIRE_AUTH, true),
      }
    );
  }
}
